export const GatedContentForm = () => {

    jQuery(document).on("gform_confirmation_loaded", function (e, form_id) {
        if (jQuery('.post-columns__form-description').length) {
            jQuery('.post-columns__form-description').css('display', 'none')
        }

    });
}